const [tenantId, catalogCode] = window.location.pathname.substring(1).split('/');

export const apiPathForTenantAndCatalog: string = `${process.env.REACT_APP_API_WEB_PATH}/${tenantId}/${catalogCode}`;
